import * as React from "react";
const BlogSVG = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={13}
    fill="none"
    {...props}
  >
    <path
      stroke="#3455CB"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M8 2.283S7 .949 4.668.949 1.334 2.283 1.334 2.283v9.333s1-.667 3.333-.667c2.334 0 3.334.667 3.334.667m0-9.333v9.333m0-9.333S9 .949 11.334.949s3.333 1.334 3.333 1.334v9.333s-1-.667-3.333-.667-3.333.667-3.333.667"
    />
  </svg>
);
export default BlogSVG;
